import React, { FC } from 'react'
import { CreateProject } from './components/CreateProject'
import { AddFeatureWizard } from './components/AddFeatureWizard'
import { ChangeProjectArea } from './components/ChangeProjectArea'
import { TrafficToolWizard } from './components/TrafficToolWizard'
import { CompareAreaWizard } from './components/CompareAreaWizard'
import { MobilityReportWizard } from './components/MobilityReportWizard'
import { CustomReportWizard } from './components/CustomReportWizard'
import { KeywordsReportWizard } from './components/KeywordsReportWizard'
import { MapEditorWizards, useMapEditorContext } from 'context/map-editor-context'
import { PredictiveReportWizard } from './components/PredictiveReportWizard'

export const Wizards: FC = () => {
  const [{ wizard }] = useMapEditorContext()

  return (
    <>
      {wizard === MapEditorWizards.PROJECT_CREATE && <CreateProject />}
      {wizard === MapEditorWizards.CHANGE_PROJECT_AREA && <ChangeProjectArea />}
      {wizard === MapEditorWizards.ADD_FEATURE && <AddFeatureWizard />}
      {wizard === MapEditorWizards.TRAFFIC_TOOL && <TrafficToolWizard />}
      {wizard === MapEditorWizards.COMPARE_AREA && <CompareAreaWizard />}
      {wizard === MapEditorWizards.MOBILITY_REPORT_TOOL && <MobilityReportWizard />}
      {wizard === MapEditorWizards.PREDICTIVE_REPORT_TOOL && <PredictiveReportWizard />}
      {wizard === MapEditorWizards.CUSTOM_REPORT_TOOL && <CustomReportWizard />}
      {wizard === MapEditorWizards.KEYWORDS_REPORT_TOOL && <KeywordsReportWizard />}
    </>
  )
}
